const LOCAL_STORAGE_KEYS = {
    linearUnits: 'Ride Report linear units',
} as const;

export default LOCAL_STORAGE_KEYS;
